import styles from "../../../../../assets/scss/common/modal/loginModal.module.scss";
import React, {useEffect, useState} from "react";
import {SignupCellphoneField} from "./component/SignupCellphoneField";
import {SignupNationField} from "./component/SignupNationField";
import {SignupNameField} from "./component/SignupNameField";
import {SignupStatus} from "../../SignupModal";
import {useSignupValidator} from "./hooks/useSignupValidator";
import {useUserAgent} from "../../../../../hooks/hooks";
import {StyleRequestType} from "../../../../../types/common";
import {Trans, useTranslation} from "react-i18next";
import {useSignupVerifyActions} from "./hooks/useSignupVerifyActions";
import {SignupSteps, ValidateSignupRequestDTO} from "../../../../../types/signup";

interface Props {
  loginStep: SignupStatus;
  email: string;
  changeSignupStep: (_: SignupStatus) => void;
  nationality: string;
  setNationality: (_: string) => void;
  name: string;
  phoneCode: string;
  phoneNumber: string;
  setName: (_: string) => void;
  setCellphone: (_: string) => void;
  setPhoneCode: (_: string) => void;
  setPhoneNumber: (_: string) => void;
}

export function SignupInfoStep1({
  loginStep,
  email,
  changeSignupStep,
  nationality,
  setNationality,
  name,
  phoneCode,
  phoneNumber,
  setName,
  setPhoneCode,
  setPhoneNumber,
                                }: Props){
  const { t } = useTranslation("signupModal");

  const [isHovered, setIsHovered] = useState(false);
  const [showNation, setShowNation] = useState(false);
  const [showCellphone, setShowCellphone] = useState(false);
  const [isValidate, setIsValidate] = useState(false)
  const {validate, nationValidate, setNationValidate,
    nameValidate, setNameValidate,
    phoneCodeValidate, setPhoneCodeValidate,
    phoneNumberValidate, setPhoneNumberValidate,
  } = useSignupValidator({
    loginStep ,nationality, name, phoneCode, phoneNumber
  });
  const {isDesktop} = useUserAgent();
  const {verifyLogs} = useSignupVerifyActions();
  const styleRequestType = StyleRequestType.SIGN_UP

  const onClickNextStep = () =>{
    const result = validate();
    if (result) {
      changeSignupStep(SignupStatus.Sign_UP_INFO_02);
    } else {
      if(isValidate) return;

      setIsValidate(true)
      const dto: ValidateSignupRequestDTO = {
        signupSteps: SignupSteps.STEP1,
        email: email,
        nationality: nationality,
        codePhone: phoneCode,
        phoneNumber: phoneNumber,
        name: name,
      }
      verifyLogs(dto).then();
    }
  }


  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const nationField = document.getElementById('nationField');
    const cellphoneField = document.getElementById('cellphoneField');

    if (showNation && nationField && !nationField.contains(target)) {
      setShowNation(false);
    }
    if (showCellphone && cellphoneField && !cellphoneField.contains(target)) {
      setShowCellphone(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line
  }, [showNation, showCellphone]);

  return (
      <>
        <div className={styles.inputArea}>

          <div className={styles.desc}>
            <Trans t={t} i18nKey={"signup.step1.title"}
                   components={{accent: <span className={styles.accent} />,br : <br />}}
            />
          </div>

          {/* 국적 */}
          <div id="nationField">
            <SignupNationField nationality={nationality} setNationality={setNationality}
                               showNation={showNation} setShowNation={setShowNation}
                               nationValidate={nationValidate} setNationValidate={setNationValidate}
                               styleRequestType={styleRequestType}
            />
          </div>

          {/*  이름  */}
          <SignupNameField name={name} setName={setName} styleRequestType={styleRequestType}
                           nameValidate={nameValidate} setNameValidate={setNameValidate}/>

          {/*  휴대폰 번호  */}
          <div id={"cellphoneField"}>
            <SignupCellphoneField phoneCode={phoneCode} setPhoneCode={setPhoneCode}
                                  phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber}
                                  showCellphone={showCellphone} setShowCellphone={setShowCellphone}
                                  phoneCodeValidate={phoneCodeValidate} setPhoneCodeValidate={setPhoneCodeValidate}
                                  phoneNumberValidate={phoneNumberValidate} setPhoneNumberValidate={setPhoneNumberValidate}
                                  styleRequestType={styleRequestType}
            />
          </div>

          <div className={`${styles.buttonsWrapper} ${isDesktop ?styles.withMarginTop : ''}`}>
            <button type="button"
                    className={`${styles.signUpNextButton} ${isHovered ? styles.signUpNextHoverButton : ''}`}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={onClickNextStep}
            >
              {t("btn.next")}
            </button>
          </div>
        </div>
      </>
  );
}